import axios from "axios";

export default {
    submitAuthentication(phoneNumber, method, bearerToken, mfaUpdated) {
        return axios.post(process.env.VUE_APP_API_URL + 'user',
            {
                "authenticationPhone": phoneNumber,
                "authenticationMethod": method,
                "mfaUpdated": mfaUpdated
            },
            {
                headers: { 'Authorization': "bearer " + bearerToken },
            }
        )
    },
    getUserDetails(bearerToken) {
        return axios.get(process.env.VUE_APP_API_URL + 'user', { headers: { 'Authorization': "bearer " + bearerToken } })
    },
    getUserEligibility(bearerToken) {
        return axios.get(process.env.VUE_APP_API_URL + 'user/eligible', { headers: { 'Authorization': "bearer " + bearerToken } })
    },
    submitFeedback(feedback, bearerToken) {
        return axios.post(process.env.VUE_APP_API_URL + 'feedback',
            {
                "mood": feedback.rating,
                "comment": feedback.comment
            },
            {
                headers: { 'Authorization': "bearer " + bearerToken }
            }
        )
    },
    acceptAgreement(bearerToken) {
        return axios.post(process.env.VUE_APP_API_URL + 'user/accept', {}, {
            headers: { 'Authorization': "bearer " + bearerToken }
        });
    }
}